export const GET_PARALLEL_MISALIGNMENT_HSS_RESULT = "GET_PARALLEL_MISALIGNMENT_HSS";
export const GET_PARALLEL_MISALIGNMENT_HSS_SUCCESS = "GET_PARALLEL_MISALIGNMENT_HSS_SUCCESS";
export const GET_PARALLEL_MISALIGNMENT_HSS_ERROR = "GET_PARALLEL_MISALIGNMENT_HSS_ERROR";
export const RESET_PARALLEL_MISALIGNMENT_HSS = "RESET_PARALLEL_MISALIGNMENT_HSS";
